export default __webpack_public_path__ + "static/media/west-coverpic.36d98947.svg";